import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { UI_MESSAGES } from 'src/app/app.contant';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { IAPIResponse } from 'src/app/modules/shared/models';
import { IFormField } from 'src/app/modules/shared/models/form-field';
import { CustomFormFieldService } from 'src/app/modules/shared/services/form-field.service';
import { RUN_PPC_FORMFIELDS } from '../../constants/run-ppc-form-fields.constant';
import { BuyerSupplierService } from '../../services/buyer-supplier.service';
import { PrBuyerHelperService } from '../../services/pr-buyer-helper.service';
import { ValidateInvalidateRequestService } from '../../services/validate-invalidate-request/validate-invalidate-request.service';

@Component({
  selector: 'app-run-ppc',
  templateUrl: './run-ppc.component.html',
  styleUrls: ['./run-ppc.component.scss']
})
export class RunPpcComponent implements OnInit {
  public title !: string;
  public line_item_number!: any;
  public formFields: Array<IFormField> = RUN_PPC_FORMFIELDS;
  public runPPCForm !: FormGroup;

  public ppcResults !: any;

  @ViewChild('grid') grid!: AgGridWrapperComponent;
  public gridApi: any;
  public gridColumnApi: any;

  public frameworkComponents: any;
  public context: any;

  public gridOptions: GridOptions = {
    defaultColDef: {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 200,
      filter: true,
      resizable: true,
      autoHeight: true,
      wrapText: true
    },
    suppressContextMenu: false,
    suppressMenuHide: false,
    sideBar: "true",
    rowGroupPanelShow: 'always',
    headerHeight: 40,
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'multiple',
    suppressCellSelection: true,
    overlayNoRowsTemplate: 'No results found.'
  };
  public columnDefs: (ColDef | ColGroupDef)[] = [];
  public prId!: string;

  constructor(public bsModalRef: BsModalRef,
    private _formFieldService: CustomFormFieldService,
    private _validateInvalidateRequestService: ValidateInvalidateRequestService,
    private _buyerHelperService: PrBuyerHelperService,
    private _buyerSupplierService: BuyerSupplierService,
    private _activatedRoute: ActivatedRoute,
    private _toastrService: ToastrService) {
    this.runPPCForm = this._formFieldService.createFormGroup(RUN_PPC_FORMFIELDS);
    this.runPPCForm.controls['line_item_number'].disable();
  }

  ngOnInit(): void {
    // this.prId = this._activatedRoute.snapshot.paramMap.get('prId');
    if (this.line_item_number) {
      this.runPPCForm.controls["line_item_number"].patchValue(this.line_item_number?.line_item_number);
      this.runPPCForm.controls["IP_MATERIAL_NUMBER"].patchValue(this.line_item_number?.material_code);
      this.runPPCForm.markAllAsTouched();
    }
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public SearchPPC(): void {
    const userProfile = this.runPPCForm.getRawValue();
    this._validateInvalidateRequestService.getPPCSearchResults(userProfile).subscribe(res => {
      if (res.data?.length) {
        this.columnDefs = this._validateInvalidateRequestService.getPPCResultsColumnDefs();
        this.ppcResults = res.data;
        this._toastrService.success(res.message);
      } else {
        this._toastrService.success(UI_MESSAGES.NO_DATA);
      }
    }, err => {
      this._toastrService.error(err.error.message || UI_MESSAGES.GENERIC_ERROR);
    });
  }

  public validatePrice(): void {
    const selectedRows: Array<any> = this.grid.getSelectedData();
    selectedRows[0].material_id = this.line_item_number.material_master_id;
    this._validateInvalidateRequestService.validatePriceWithPPC(selectedRows[0]).subscribe(res => {
      this._toastrService.success(res.message);
      this.captureTaxcode();
      this.onModalClose();
    }, err => {
      this._toastrService.error(err.error.message || UI_MESSAGES.GENERIC_ERROR);
      this.onModalClose();
    });
  }

  public onGridReady() {
    this.grid.autoSizeAll(false);
  }

  private runAutoPO() {
    this._buyerSupplierService.createAutoPO(this.prId).subscribe((res: IAPIResponse<any>) => {
      this._toastrService.success(res.message);
    }, (err: any) => {
        this._buyerHelperService.failedPOCreationModal(err.error);
      });
  }

  private captureTaxcode() {
    const modalRef = this._buyerHelperService.captureTaxcode(this.prId);
  }

}
